import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BuildingDataService } from '../building-data.service';
import { delay, map, of, startWith } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { ActivatedRoute } from '@angular/router';
import { BuildingImagesDialogComponent } from '../../building-Image/building-images-dialog/building-images-dialog.component';

@Component({
  selector: 'app-building-image-dialog',
  templateUrl: './building-image-dialog.component.html',
  styleUrls: ['./building-image-dialog.component.scss']
})
export class BuildingImageDialogComponent {
 counsellingReport!: any
  statelist: any;
  stateOptions: any;
  cityOptions: any;
  citylist: any;
  campuslist: any;
  campusOptions: any;
  stateId: any;
  cityId: any;
  campusid: any;
  data1: string;
  lastSelectedLabel = '';

  constructor(private verification:BuildingDataService, private spinner: NgxSpinnerService, private fb: FormBuilder, private toast: ToastmessageService, private route: ActivatedRoute, private dialog: MatDialog, private dialogRef: MatDialogRef<BuildingImageDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,) { }
  ngOnInit(): void {
     // this.adapter.setLocale('en-GB');
    console.log(this.data);

    this.counsellingReport = new FormGroup({
      StateControl: new FormControl('', Validators.required),
      StateControl2: new FormControl('', Validators.required),
      cityControl: new FormControl('', Validators.required),
      cityControl12: new FormControl('', Validators.required),
      noImage: new FormControl(false),
      noLocation: new FormControl(false),
      BuildingImage:new FormControl(false),

    });


    this.getstates()
    if (this.data) {
      this.getstates(); // always call this

      if (this.data.stateId) {
        this.getcity(this.data.stateId);
      }

      if (this.data.cityId) {
        // this.getCampus(this.data.cityId);
        // this.getconseller(this.data.campusId);
      }
      if (this.data.campusId) {
        // this.getconseller(this.data.campusId);
      }

      if (this.data.counselCatId) {
        // this.getIssues(this.data.counselCatId)
      }
      this.counsellingReport.patchValue({
        StateControl: this.data.stateId || null,
        cityControl: this.data.cityId || null,
      });
    }
  }


  private Filter(value: string, list: any[], name: string): any[] {
    const searchValue = value.trim().toLocaleLowerCase();
    let filteredList = list.filter((item: any) => item[name] && item[name].trim().toLocaleLowerCase().includes(searchValue));
    return filteredList;
  }
  getCampus1(e: any) {

  }

  getCampus(e: any) {
    this.cityId = typeof e === 'object' ? e.cityId : e;
    if (typeof e === 'object' && e.cityName) {
      this.lastSelectedLabel = ` ${e.cityName}`;
    }

  }

  getReport() {
    const formValue = this.counsellingReport.value;
    const paramsObj: any = {
      stateId: this.stateId,
      cityId: this.cityId,
      noImage: formValue.noImage ?? false,
      noLocation: formValue.noLocation ?? false,
      buildingImage:formValue.BuildingImage ??false,
      lastSelectedLabel: this.lastSelectedLabel

    };
    this.dialogRef.close({ params: paramsObj });
  }

  getcity(e: any) {
    this.spinner.show()
    this.stateId = typeof e === 'object' ? e.stateId : e;
    if (typeof e === 'object' && e.stateName) {
      this.lastSelectedLabel = ` ${e.stateName}`;
    }
    this.verification.getcity(this.stateId).subscribe((res: any) => {
      this.citylist = res
      this.cityOptions = this.counsellingReport.get('cityControl12').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.citylist, 'cityName'))
      );
      // this.checkAndFetchReasons()
    })
    this.spinner.hide()
  }
  getstates() {
    this.spinner.show()
    this.verification.getstate().subscribe((res: any) => {
      this.statelist = res
      this.stateOptions = this.counsellingReport.get('StateControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.statelist, 'stateName'))
      );
    })
    this.spinner.hide()
  }
  clearCity() {
    this.counsellingReport.get('cityControl')?.reset();
    this.cityOptions = of([]).pipe(delay(0));
    this.citylist = '';
    // this.clearCampus();
  }

  clearCampus() {
    this.counsellingReport.get('campusControl')?.reset();
    this.campusOptions = of([]).pipe(delay(0));
    this.campuslist = '';
    // this.clearCounsler();
  }
}
